<template>
  <Dropdown
    v-bind="$attrs"
    v-model="inputValue"
    :is-required="isRequired"
    :options="countries"
    :placeholder="t('select_country')"
    :error="error"
    filterable
    :test-id="name || testId"
  >
    <template #prefix>
      <Flag v-if="inputValue" :country-code="inputValue" />
    </template>
  </Dropdown>
</template>

<script setup lang="ts">
  import { computed, ref } from "vue";

  const { t } = useI18n();

  const props = withDefaults(
    defineProps<{
      error?: string;
      name?: string;
      selectDefault?: boolean;
      testId?: string;
      isRequired?: boolean;
    }>(),
    {
      error: undefined,
      name: "",
      selectDefault: false,
      testId: "country-select",
      isRequired: false,
    }
  );
  const _modelValue = defineModel<string>();

  onMounted(() => {
    if (props.selectDefault) {
      inputValue.value = "DK";
    }
  });

  const { value: inputValue, errorMessage } = useField(() => props.name, undefined, {
    syncVModel: props.name ? false : true,
    controlled: !!props.name,
  });

  const error = computed(() => {
    return props.error || errorMessage.value;
  });

  const input = ref<HTMLElement | null>(null);

  const el = computed(() => {
    return input.value?.input;
  });

  const countries = getCountrySelectOptions();

  defineExpose({
    el,
  });
</script>
